// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b6661122","239":"1b430e0c","453":"4b2c0f42","667":"82045b3c"}[chunkId] + ".chunk.js";
};